import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";

import { Button } from 'primereact/button';
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { showToast } from "../ToastManager";

import Utils from "../../utilities/Utils";

import FinanceiroService from '../../service/FinanceiroService';

const financeiroService = new FinanceiroService(); // Create an instance of FinanceiroService

const iss = localStorage.getItem('iss');

const VisualizarPagamento = () => {

    let pagamentoObj = {
        id: 0,
        agendamento_id: 0,
        ipag_payments_id: 0,
        valor_pago: 0,
        valor_star: 0,
        valor_prestador: 0,
        forma_pagamento: null,
        data_pagamento: null,
        excluido: false,
        agendamentos: {
            data_agendamento: null,
            user: {
                username: null,
                email: null,
                profile: {
                    name: null,
                    phone: 0,
                    cpf: 0
                }
            },
            prestadorTipoAgendamento: {
                percentual_servico: 0,
                ativo: true,
                tipoAgendamento: {
                    id: 0,
                    nome: null
                },
                prestador: {
                    nome: null,
                    user: {
                        id: 0,
                        email: null,
                        companies: [
                            {
                                id: 0,
                                name: null
                            }
                        ]
                    }
                }
            }
        }

    };

    const history = useHistory();
    const [pagamento, setPagamento] = useState(pagamentoObj);
    const [loading, setLoading] = useState(false);

    const { id } = useParams();

    const initPagamento = useCallback(async () => {
        try {
            setLoading(true);
            financeiroService.getPagamento(iss, id).then(data => {
                pagamentoObj = data.data.rows[0];
                setLoading(false);
                setTimeout(() => {
                    setPagamento(pagamentoObj);
                }, 200);
            });
        } catch (error) {
            console.error("Erro ao carregar pagamentos:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar pagamentos' });
        } finally {
            setLoading(false);
        }
    }, [iss]);

    useEffect(() => {
        initPagamento();
    }, [initPagamento]);

    return (
        <div className="grid">
            <h4>Informações do pagamento</h4>
            <div className="col-12">
                <div className="card">

                    <div style={{ marginTop: 25 }} className="p-fluid formgrid grid">
                        <div style={{ marginTop: 25 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <InputText value={pagamento.id} disabled id="id" type="text" />
                                <label htmlFor="id">Código Pagamento</label>
                            </span>
                        </div>
                        <div style={{ marginTop: 25 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <InputText value={pagamento.agendamentos.user.profile.name} disabled
                                    id="name" type="text" />
                                <label htmlFor="name">Cliente</label>
                            </span>
                        </div>
                        <div style={{ marginTop: 25 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <InputMask value={Utils.formatCpf(pagamento.agendamentos.user.profile.cpf)} disabled
                                    id="cpf" type="text" />
                                <label htmlFor="cpf">CPF</label>
                            </span>
                        </div>
                        <div style={{ marginTop: 25 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <InputText value={pagamento.agendamentos.prestadorTipoAgendamento.prestador.nome} disabled
                                    id="nome" type="text" />
                                <label htmlFor="nome">Prestador</label>
                            </span>
                        </div>
                        {/* <div style={{ marginTop: 25 }} className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <InputMask value={Utils.formatCpf(pagamento.agendamentos.agendaPrestador.prestador.cpf)} disabled
                                    id="cpf" type="text" />
                                <label htmlFor="cpf">CPF</label>
                            </span>
                        </div> */}
                        <div style={{ marginTop: 25 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <InputText value={Utils.formatData(pagamento.agendamentos.data_agendamento)} disabled id="data_agendamento" type="text" />
                                <label htmlFor="data_agendamento">Data Agendamento</label>
                            </span>
                        </div>
                        <div style={{ marginTop: 25 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <InputText value={Utils.formatData(pagamento.data_pagamento)} disabled
                                    id="data_pagamento" type="text" />
                                <label htmlFor="data_pagamento">Data Pagamento</label>
                            </span>
                        </div>
                        <div style={{ marginTop: 25 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <InputText value={pagamento.forma_pagamento} disabled
                                    id="forma_pagamento" type="text" />
                                <label htmlFor="forma_pagamento">Forma de pagamento</label>
                            </span>
                        </div>
                        <div style={{ marginTop: 25 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <InputText value={Utils.formatCurrency(pagamento.valor_pago)} disabled id="data_agendamento" type="text" />
                                <label htmlFor="valor_pago">Valor Pago</label>
                            </span>
                        </div>
                        <div style={{ marginTop: 25 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <InputText value={Utils.formatCurrency(pagamento.valor_star)} disabled
                                    id="valor_star" type="text" />
                                <label htmlFor="valor_star">Valor Star</label>
                            </span>
                        </div>
                        <div style={{ marginTop: 25 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <InputText value={Utils.formatCurrency(pagamento.valor_prestador)} disabled
                                    id="valor_prestador" type="text" />
                                <label htmlFor="valor_prestador">Valor Final</label>
                            </span>
                        </div>

                        {/* <Button label={id != null ? 'Atualizar' : 'Cadastrar'} loading={loading} style={{ width: '100%', marginTop: 25 }}
                            onClick={cadastrar} className="mr-2 mb-2"></Button>  */}

                        <div onClick={history.goBack} style={{ width: '100%', marginTop: 25, textAlign: 'center', cursor: 'pointer' }}>
                            <i className="pi pi-arrow-left"></i><span style={{ marginLeft: 10, }}>Voltar</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(VisualizarPagamento, comparisonFn);
